import React from "react";
import { detailsActu, likeActu, listActu, vueActu } from "../actions/actus";
import { dispDateMonth, getDomain, getIdInUrl, tempAlWait } from "../helpers";
import Alert from "../components/Alert";
import ShortActus from "../components/ShortActus";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy, faEllipsisVertical, faEye, faHeart, faShare, faX } from "@fortawesome/free-solid-svg-icons";
import { faFacebookF, faLinkedin } from "@fortawesome/free-brands-svg-icons";
import { connect } from "react-redux";
import { createEditor } from "lexical";
import { $generateHtmlFromNodes } from "@lexical/html";
import { AutoLinkNode, LinkNode } from "@lexical/link";
import { HeadingNode, QuoteNode } from "@lexical/rich-text";
import { CodeHighlightNode, CodeNode } from "@lexical/code";
import { TableNode, TableCellNode, TableRowNode } from "@lexical/table";
import { ListNode, ListItemNode } from "@lexical/list";
import { ImageNode } from "../components/editor/CustomNodes/ImageNode";

class Article extends React.Component {
    state = {
        alert: {
            active: false,
            type: '',
            title: '',
            desc: ''
        },
        data: null,
        id: null,
        optsActive: false,
    }

    componentDidMount() {
        document.title = "Article - DiscovRide | Calendriers d'affluence, Temps d'attente de parcs d'attractions (Futuroscope, Parc Asterix...)";
        if (this.props.canContinue) {
            this.props.listActu({nb: 3});
            this.setState({
                alert: tempAlWait(),
                id: getIdInUrl()
            })
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.canContinue != this.props.canContinue) {
            if (this.props.canContinue) {
                this.props.listActu({nb: 3});
                this.setState({
                    alert: tempAlWait(),
                    id: getIdInUrl()
                })
            }
        }
        
        if (this.state.id != prevState.id) {
            this.props.detailsActu({actuId: this.state.id});
        }

        if (this.props.redDetActu != prevProps.redDetActu) {
            let tempDt = this.props.redDetActu.datas;
            const editor = createEditor({nodes: [
                HeadingNode,
                ListNode,
                ListItemNode,
                QuoteNode,
                CodeNode,
                CodeHighlightNode,
                TableNode,
                TableCellNode,
                TableRowNode,
                AutoLinkNode,
                LinkNode,
                ImageNode
            ]});
            const editorState = editor.parseEditorState(tempDt.contenu);
            editor.setEditorState(editorState);
            let tempDatas = {
                id: tempDt.id,
                createdAt: tempDt.createdAt,
                duree: tempDt.duree,
                title: tempDt.title,
                contenu: null,
                description: tempDt.description,
                codeYtb: tempDt.codeYtb,
                nbVue: tempDt.nbVue,
                nbLike: tempDt.nbLike,
                isLike: tempDt.isLike,
            }
            editor.update(() => {
                const htmlString = $generateHtmlFromNodes(editor);
                tempDatas.contenu = htmlString;
            })
            console.log(this.props.redDetActu.alert)
            this.setState({
                alert: this.props.redDetActu.alert,
                data: tempDatas
            })
            if (this.props.redDetActu.alert.type == "succ") {
                this.props.vueActu({actuId: this.state.id});
            }
        }

        if (this.props.redViewActu != prevProps.redViewActu) {
            if (this.props.redViewActu.alert.type == "succ") {
                let tempData = this.state.data;
                tempData.nbVue += 1;
                this.setState({
                    alert: this.props.redViewActu.alert,
                    data: tempData
                })
            } else {
                this.setState({
                    alert: this.props.redViewActu.alert
                })
            }
        }

        if (this.props.redLikeActu != prevProps.redLikeActu) {
            if (this.props.redLikeActu.alert.type == "succ") {
                let tempData = this.state.data;
                if (tempData.isLike) {
                    tempData.isLike = false;
                    tempData.nbLike -= 1;
                } else {
                    tempData.isLike = true;
                    tempData.nbLike += 1;
                }
                this.setState({
                    alert: this.props.redLikeActu.alert,
                    data: tempData
                })
            } else {
                this.setState({
                    alert: this.props.redLikeActu.alert
                })
            }
        }
    }

    handleLike = (el) => {
        this.props.likeActu({actuId: this.state.id});
    }

    render() {
        return <main className="blogp__main particle">
            {/** Article **/}
            <article className="particle__art">
                {/** Header **/}
                <header className="particle__hdr">
                    <img
                        src={`${getDomain()}image/logo/${this.props.idtt?.logo}`}
                        alt={`Logo de ${this.props.idtt?.name}`}
                        className="particle__logo"
                    />
                    <div className="particle__hdrtxt">
                        {this.props.idtt?.name != null && <span className="particle__name">{this.props.idtt?.name}</span>}
                        {this.state.data?.createdAt.date != null && <span className="particle__name">{dispDateMonth(this.state.data?.createdAt.date)}</span>}
                        <span className="particle__name">{this.state.data?.duree != null ? `${this.state.data?.duree} de lecture` : ''}</span>
                    </div>
                    <button
                        title={`${this.state.optsActive ? "Fermer les options" : "Ouvrir les options"}`}
                        aria-label={`${this.state.optsActive ? "Fermer les options" : "Ouvrir les options"}`}
                        className="particle__hdrbtn"
                        onClick={() => this.setState({optsActive: !this.state.optsActive})}
                    >
                        <FontAwesomeIcon icon={faEllipsisVertical} />
                    </button>
                    <div className={`particle__opts ${this.state.optsActive && "particle__opts--active"}`}>
                        <button
                            title="Partager le post"
                            aria-label="Partager le post"
                            className="particle__optbtn"
                        >
                            <FontAwesomeIcon icon={faShare} />
                            <span className="particle__optbtntxt">Partager le post</span>
                        </button>
                    </div>
                </header>

                {/** Title **/}
                <h2 className="particle__ttl">{this.state.data?.title}</h2>

                {/** Vidéo ytb **/}
                <iframe width="560" height="315" src={`https://www.youtube.com/embed/${this.state.data?.codeYtb}`} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>

                {/** Description **/}
                <p className="particle__desc">{this.state.data?.description}</p>

                {/** Contenu **/}
                <div className="particle__contenu" dangerouslySetInnerHTML={{ __html: this.state.data?.contenu }} />

                {/** Partage **/}
                <div className="particle__prtgs">
                    <button
                        title="Partager sur Facebook"
                        aria-label="Partager sur Facebook"
                        className="particle__prtgbtn"
                    >
                        <FontAwesomeIcon icon={faFacebookF} />
                    </button>
                    <button
                        title="Partager sur X"
                        aria-label="Partager sur X"
                        className="particle__prtgbtn"
                    >
                        <FontAwesomeIcon icon={faX} />
                    </button>
                    <button
                        title="Partager sur LinkedIn"
                        aria-label="Partager sur LinkedIn"
                        className="particle__prtgbtn"
                    >
                        <FontAwesomeIcon icon={faLinkedin} />
                    </button>
                    <button
                        title="Copier le lien"
                        aria-label="Copier le lien"
                        className="particle__prtgbtn"
                    >
                        <FontAwesomeIcon icon={faCopy} />
                    </button>
                </div>

                {/** Footer **/}
                <footer className="particle__ftr">
                    {/** Vues **/}
                    <div className="particle__ftritem">
                        <FontAwesomeIcon icon={faEye} />
                        <span className="particle__ftritemnb">{this.state.data?.nbVue}</span>
                    </div>
                    
                    {/** Likes **/}
                    <button
                        title={this.state.data?.isLike ? "Je n'aime plus" : "J'aime"}
                        aria-label={this.state.data?.isLike ? "Je n'aime plus" : "J'aime"}
                        className={`particle__ftritem particle__ftritem--like ${this.state.data?.isLike && "particle__ftritem--isLike"}`}
                    >
                        <FontAwesomeIcon icon={faHeart} />
                        {
                            this.state.data?.nbLike > 0 &&
                            <span className="particle__ftritemnb">{this.state.data?.nbLike}</span>
                        }
                    </button>
                </footer>
            </article>

            {/** Publication récentes **/}
            <ShortActus changeAlert={(al) => this.setState({alert: al})} />

            {/** Commentaire **/}

            <Alert alert={this.state.alert} />
        </main>
    }
}

const mapStateToProps = state => {
    return {
        redDetActu: state.redDetActu,
        redLikeActu: state.redLikeActu,
        redViewActu: state.redViewActu,
    }
}

const mapDispatchToProps = {
    detailsActu,
    likeActu,
    vueActu,
    listActu
}

export default connect(mapStateToProps, mapDispatchToProps)(Article);

// todo : ajouter système de commentaire